import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

export interface DashboardPromocoesRequest {
  userId: number;
  dataInicio: string;
  dataFim: string;
  tipoDados: string;
}

export interface DashboardPromocoesSeller {
  sellerId: number;
  vendedor: string;
  vendasReais: number;
  quantidade: number;
  litros: number;
  pedidos: number;
}

export interface DashboardPromocao {
  promocaoId: number;
  promocao: string;
  flagNaoAplicaFatorPontuacaoFin: boolean;
  vendasReais: number;
  quantidade: number;
  litros: number;
  pedidos: number;
  sellers: DashboardPromocoesSeller[];
}

export interface DashboardPromocaoProduto {
  promocaoId: number;
  promocao: string;
  produtoEspecialId: number;
  produtoId: number;
  codigo: string;
  produto: string;
  precoPromocao: number;
  vendasReais: number;
  quantidade: number;
  litros: number;
  pedidos: number;
  sellers: DashboardPromocoesSeller[];
}

export interface DashboardPromocoesResumo {
  promocoes: DashboardPromocao[];
  produtos: DashboardPromocaoProduto[];
}

@Injectable({
  providedIn: 'root'
})
export class DashboardPromocoesService {
  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private toastr: ToastrService
  ) { }

  public getResumo(payload: DashboardPromocoesRequest): Observable<DashboardPromocoesResumo> {
    return this.http
      .post<DashboardPromocoesResumo>(this.baseUrl + 'api/DashboardPromocoes/GetResumo', payload)
      .pipe(
        catchError(() => {
          this.toastr.error('', 'Erro ao carregar Dashboard Uso Promocoes. Contate o suporte...');
          return of({ promocoes: [], produtos: [] });
        })
      );
  }
}
